var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"persistent":_vm.persistent},on:{"hide":function($event){return _vm.$emit('cancel')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }